import { appConstants, getCurrentLanguage } from "@abp";
import { Turnstile, TurnstileInstance } from "@marsidev/react-turnstile";
import { useEffect, useRef } from "react";

interface IProps {
  setToken: (token: string) => void;
  resetRef?: React.MutableRefObject<(() => void) | undefined>;
}

export const SharedTurnstile: React.FC<IProps> = ({ setToken, resetRef }) => {
  const { turnstileSiteKey } = appConstants;
  const ref = useRef<TurnstileInstance | null>(null);

  useEffect(() => {
    if (resetRef) resetRef.current = () => ref.current?.reset();
  }, [resetRef]);

  return (
    <Turnstile
      ref={ref}
      style={{ width: "100%" }}
      options={{
        language: getCurrentLanguage(),
        size: "flexible",
        theme: "light",
      }}
      siteKey={turnstileSiteKey}
      onSuccess={setToken}
      onExpire={() => ref.current?.reset()}
      onError={() => ref.current?.reset()}
    />
  );
};
